import { render, staticRenderFns } from "./BackgroundCoin.vue?vue&type=template&id=40f3966b&"
import script from "./BackgroundCoin.vue?vue&type=script&lang=ts&"
export * from "./BackgroundCoin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports